<compass-pois-table [poisTableList]="companiesList" style="width: 100%;">
</compass-pois-table>